import React from 'react';

import { InputAdornment, SvgIcon } from '@material-ui/core';

import { search } from '../../../../assets/icons';
import { RoundedButton } from '../../RoundedButton';
import { FormInput, FormInputProps } from '../FormInput';
import styles from './SearchInput.module.scss';

export interface SearchInputProps extends FormInputProps {
	clearSearchQuery: () => void;
}

export const SearchInput = ({
	value,
	clearSearchQuery,
	...rest
}: SearchInputProps) => (
	<FormInput
		{...rest}
		type="text"
		value={value}
		autoComplete="off"
		className={styles['search-input']}
		inputClassName={styles['search-input__input']}
		startAdornment={
			<InputAdornment
				position="start"
				classes={{
					root: styles['search-input__icon'],
				}}
			>
				<SvgIcon component={search} fontSize="inherit" />
			</InputAdornment>
		}
		endAdornment={
			value?.length ?? 0 ? (
				<InputAdornment position="end">
					<RoundedButton onClick={clearSearchQuery}>Clear</RoundedButton>
				</InputAdornment>
			) : null
		}
	/>
);
